import { FaInstagram } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const instagramBaseSettings: SocialPlatformBaseSettings = {
  name: "Instagram",
  icon: FaInstagram,
  fields: {
    caption: "required",
    location: "optional",
    altText: "optional",
    firstComment: "optional", // Common practice
    userTags: "optional",
  },
  limits: {
    caption: 2200,
    hashtags: 30,
  },
  notes: ["Ideal caption length: < 125 characters.", "Ideal hashtags: 5-10."],
  postTypes: {
    post: {
      limits: {
        images: 10, // Carousel
        videos: 1,
        videoDurationSeconds: 60,
      },
      notes: ["Can be single image/video or carousel."],
    },
    reel: {
      nameSuffix: " Reel",
      limits: {
        images: 0,
        videos: 1,
        videoDurationSeconds: 90,
      },
      notes: ["Reels are vertical, short-form videos."],
    },
    story: {
      nameSuffix: " Story",
      fields: {
        caption: "optional",
        polls: "optional",
        linkAttachment: "optional",
        firstComment: "not_allowed",
      },
      limits: {
        images: 1,
        videos: 1,
        videoDurationSeconds: 60, // Segments are 15s, total 60s?
        hashtags: 10, // Fewer hashtags typically used
      },
      notes: ["Stories are ephemeral (24h), support polls/links via stickers."],
    },
  },
};
